import { MoneyPerPeriod } from 'components/money';

type Props = {
  cost?: string | number | null;
  suffix?: string;
  testId?: string;
};

export const NodeCostCell = ({ cost, testId, suffix = 'h' }: Props) => {
  if (!cost) {
    return <span>-</span>;
  }

  return (
    <MoneyPerPeriod
      moneyProps={{
        amount: +cost,
        fixed: 3,
        precision: 3,
      }}
      primaryTextProps={{ variant: 'inherit' }}
      suffix={suffix}
      compact
      testId={testId}
      suffixTextProps={{
        variant: 'P12R',
        fontSize: undefined,
        color: 'grey.400',
      }}
    />
  );
};
